import { render, staticRenderFns } from "./WGSearch.vue?vue&type=template&id=07a3b871&scoped=true&"
import script from "./WGSearch.vue?vue&type=script&lang=js&"
export * from "./WGSearch.vue?vue&type=script&lang=js&"
import style0 from "./WGSearch.vue?vue&type=style&index=0&id=07a3b871&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../tasks/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a3b871",
  null
  
)

export default component.exports